import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SwitchChainAction } from './chainActions';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localstorage';
import {
  NetworkChainIds,
  defaultNetwork,
  enabledNetworksChainIds,
} from '@dapp/multi-lib/network';

// Define a type for the slice state
interface ChainState {
  selectedNetwork: NetworkChainIds | null;
  // value: NetworkChainIds | null;
  chainId: NetworkChainIds | null;
  error: string | null;
  cardanoWalletAddress: string | null;
  showCardanoStaking: boolean;
}

type ChangeSelectedNetwork = PayloadAction<NetworkChainIds>;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ActionUpdateBlock = PayloadAction<{ number: number; timestamp: number }>;

const initialChain =
  (parseInt(
    (typeof window !== 'undefined' &&
      localStorage.getItem(LOCAL_STORAGE_KEYS.NETWORK)) ||
      ''
  ) as NetworkChainIds) || (defaultNetwork.id as NetworkChainIds);

// Define the initial state using that type
const initialState: ChainState = {
  selectedNetwork: initialChain,
  // value: initialChain,
  chainId: initialChain,
  error: null,
  cardanoWalletAddress: null,
  showCardanoStaking: true,
};

export const chainSlice = createSlice({
  name: 'chain',
  initialState,
  reducers: {
    switchChain: (state, action: SwitchChainAction) => {
      const chainId = action.payload;

      if (enabledNetworksChainIds.includes(chainId)) {
        // state.value = chainId;
        state.chainId = chainId;
        state.error = null;
      } else {
        // state.value = null;
        state.chainId = null;
        state.error = 'Chain not supported';
      }
    },
    // setCardanoWalletAddress: (state, action: CardanoAddresAction) => {
    //   state.cardanoWalletAddress = action.payload;
    // },
    // removeCardanoWalletAddress: (state) => {
    //   state.cardanoWalletAddress = null;
    // },
    // setShowCardanoStaking: (state, action: EnableCardanoAction) => {
    //   state.showCardanoStaking = action.payload;
    // },
    setSelectedNetwork: (state, action: ChangeSelectedNetwork) => {
      state.selectedNetwork = action.payload;
    },
    clearChain: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  switchChain,
  clearChain,
  // setCardanoWalletAddress,
  // removeCardanoWalletAddress,
  // setShowCardanoStaking,
  setSelectedNetwork,
} = chainSlice.actions;

export const chainReducer = chainSlice.reducer;
